module.exports = __webpack_public_path__ + "img/move13.3682e586.jpg";